<template>
  <v-card elevation="0">
    <v-card-text class="pa-0">
      <v-row no-gutters>
        <v-col cols="12">
          <p class="px-2 primary--text">{{ $t("common.pt") }}</p>
          <RichText
            :custom-toolbar-options="toolbarOptions"
            v-model="ptContent"
            :useCustomImageHandler="true"
            @image-added="handleImageAdded"
            @update:content="ptContent = $event"
            id="help-center-richtext"
          />
        </v-col>

        <v-checkbox
          v-model="translate"
          :label="$t('help-center.add-translations')"
          class="ml-2 mb-4"
          hide-details
        ></v-checkbox>

        <v-col v-if="translate" cols="12">
          <p class="px-2 primary--text">{{ $t("common.en") }}</p>
          <RichText
            :custom-toolbar-options="toolbarOptions"
            v-model="enContent"
            :useCustomImageHandler="true"
            @image-added="handleImageAdded"
            @update:content="enContent = $event"
            id="help-center-richtext"
          />
        </v-col>

        <v-col v-if="translate" cols="12" class="mt-12">
          <p class="px-2 primary--text">{{ $t("common.es") }}</p>
          <RichText
            :custom-toolbar-options="toolbarOptions"
            v-model="esContent"
            :useCustomImageHandler="true"
            @image-added="handleImageAdded"
            @update:content="esContent = $event"
            id="help-center-richtext"
          />
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions class="justify-end">
      <v-btn
        @click="$emit('close')"
        color="primary"
        min-width="100"
        outlined
        rounded
      >
        {{ $t("help-center.cancel") }}
      </v-btn>
      <v-btn
        @click="handleSubmit"
        color="primary"
        elevation="0"
        min-width="100"
        rounded
      >
        {{ $t("help-center.save") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
import RichText from "../RichText.vue";

export default {
  name: "HelpCenterFields",
  components: {
    RichText,
  },
  props: {
    topic: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      translate: false,
      ptContent: "",
      enContent: "",
      esContent: "",
      toolbarOptions: [
        ["link", "image", "video"],
        ["bold", "italic", "underline"],
        [{ align: [] }],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }],
        [{ size: [] }],
        ["clean"],
      ],
    };
  },
  computed: {
    content() {
      return `<pt_BR>${this.ptContent}</pt_BR><en_US>${this.enContent}</en_US><es_ES>${this.esContent}</es_ES>`;
    },
  },
  methods: {
    ...mapActions([
      "updateHelpCenterTopic",
      "fetchHelpCenterTopics",
      "uploadInviteImage",
    ]),
    async handleSubmit() {
      const data = {
        subject: this.topic.value,
        content: this.content,
        userType: this.topic.userType,
        id: this.topic.id,
      };

      await this.updateHelpCenterTopic(data);

      this.$emit("save", { title: this.topic.title, ...data });
    },
    readFileAsBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = event => {
          resolve(event.target.result);
        };

        reader.onerror = event => {
          reject(event.target.error);
        };

        reader.readAsDataURL(file);
      });
    },
    async handleImageAdded(file, Editor, cursorLocation) {
      const base64 = await this.readFileAsBase64(file);
      await this.uploadInviteImage(base64).then(result => {
        let url = result.url;
        Editor.insertEmbed(cursorLocation, "image", url);
        this.isLoading = false;
      });
    },
  },
  mounted() {
    this.ptContent = this.topic.contentPt;
    if (this.topic.contentEn || this.topic.contentEs) {
      this.translate = true;
      this.enContent = this.topic.contentEn;
      this.esContent = this.topic.contentEs;
    }
  },
};
</script>

<style>
#help-center-richtext {
  min-height: 500px !important;
}
</style>
<style lang="scss" scoped></style>
